export default __webpack_public_path__ + "static/media/34k.09f258d6.md";